import { render, staticRenderFns } from "./PurchasingDetailList.vue?vue&type=template&id=6c6d8d30"
import script from "./PurchasingDetailList.vue?vue&type=script&lang=js"
export * from "./PurchasingDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports